export default {"src":"/_next/static/media/profile.d60d3d6c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};